import {ClinicGroupAction} from '../actions/GroupActions';
import {
  Group,
  GroupClinic,
  GroupHealthCareProvider,
  // GroupHealthCareProviderOrgMapping,
  GroupUser
} from '../../services/service-mappers/ClinicServiceMapper';
import {
  SET_ALL_GROUPS,
  SET_SELECTED_GROUP,
  SET_SELECTED_GROUP_CLINICS,
  SET_SELECTED_GROUP_USERS,
  SET_GROUP_USERS,
  SET_GROUP_CLINICS,
  SET_SELECTED_GROUP_CARD_MACHINES,
  SET_SELECTED_GROUP_ID,
  SET_ACCESS_OF_CLINICS,
  RESET_GROUP_STATE,
  SET_LOGOUT_AUTH,
  SET_SELECTED_GROUP_HEALTHCARE_PROVIDERS,
  SET_SELECTED_GROUP_ENABLED_MODULES
} from './../actions/Index';

export interface GroupStateType {
  allGroups: Group[];
  selectedGroup: Group | null;
  selectedGroupUsers: GroupUser[] | [];
  selectedGroupClinics: GroupClinic[] | [];
  selectedGroupHealthCareProviders: GroupHealthCareProvider[] | [];

  // TODO: add types
  selectedGroupCardMachines: any;

  // TODO:
  accessOfClinics: any[];
  selectedGroupId: Group['id'] | null;

  // will store prev fetched users of a group.
  allGroupUsers: Map<Group['id'], GroupUser[]>;
  // will store prev fetched clinics of group
  allGroupClinics: Map<Group['id'], GroupClinic[]>;
  selectedGroupEnabledModules: any;
}

const initState: GroupStateType = {
  allGroups: [],
  selectedGroup: null,
  selectedGroupId: null,
  selectedGroupUsers: [],
  selectedGroupClinics: [],
  selectedGroupCardMachines: [],
  accessOfClinics: [],
  selectedGroupHealthCareProviders: [],

  // will store prev fetched users of a group.
  allGroupUsers: new Map(),
  // will store prev fetched clinics of group
  allGroupClinics: new Map(),
  selectedGroupEnabledModules: []
};

export default function (
  state = initState,
  action: ClinicGroupAction
): GroupStateType {
  const {type} = action;
  const payload: any = action.payload;
  switch (type) {
    case SET_ALL_GROUPS:
      return {
        ...state,
        allGroups: payload.groups
      };
    case SET_SELECTED_GROUP_ID:
      return {
        ...state,
        selectedGroupId: payload.groupId
      };
    case SET_SELECTED_GROUP:
      return {
        ...state,
        selectedGroup: payload.selectedGroup
      };
    case SET_SELECTED_GROUP_USERS:
      return {
        ...state,
        selectedGroupUsers: (payload.groupUsers as any) || []
      };
    case SET_SELECTED_GROUP_CLINICS:
      return {
        ...state,
        selectedGroupClinics: payload?.groupClinics || []
      };
    case SET_GROUP_USERS: {
      // TODO: create a deep copy allGroupUsers
      const updatedGroupUsers = state.allGroupUsers;
      updatedGroupUsers.set(payload.groupId, payload.groupUsers);
      return {
        ...state,
        allGroupUsers: updatedGroupUsers
      };
    }
    case SET_SELECTED_GROUP_HEALTHCARE_PROVIDERS:
      return {
        ...state,
        selectedGroupHealthCareProviders: payload.providers
      };
    case SET_GROUP_CLINICS: {
      // TODO: create a deep copy allGroupUsers
      const updatedGroupClinics = state.allGroupClinics;
      updatedGroupClinics.set(payload.groupId, payload.groupClinics);
      return {
        ...state,
        allGroupClinics: updatedGroupClinics
      };
    }
    case SET_ACCESS_OF_CLINICS:
      return {
        ...state,
        accessOfClinics: payload.accessOfClinics
      };
    case SET_SELECTED_GROUP_CARD_MACHINES:
      return {
        ...state,
        selectedGroupCardMachines: payload.cardMachines
      };
    case SET_SELECTED_GROUP_ENABLED_MODULES:
      return {
        ...state,
        selectedGroupEnabledModules: payload.modules
      };
    case RESET_GROUP_STATE:
    case SET_LOGOUT_AUTH:
      return initState;
    default:
      return state;
  }
}
